import React, { useContext } from "react";
import logo from "../../../assets/images/logo.png";
import style from "./Logout.module.css";
import { Link, useLocation } from "react-router-dom";
import { StoreContext } from "../../../App";
import { History } from "../../../utils/NavigationHistoryUtils";

function Logout() {
  const { state } = useLocation();
  const { auth } = useContext(StoreContext);

  auth.clearAll();
  localStorage.clear();

  if ((state && state.navigateToLogin) || !auth.user) return History.navigate("/login");

  return (
    <div className={style.logoutWrapper}>
      <div className={style.logoutBlock}>
        <div className={style.logoutLogoWrapper}>
          <img src={logo} alt={'logo'} />
        </div>
        <div className={style.logoutContent}>
          <h1>{'Ви успішно вийшли зі свого облікового запису'}</h1>
          <p>
            {'Дякуємо за використання нашої платформи.'}
            <br />
            {'Сподіваємось побачити вас знову.'}
          </p>
          <Link to={"/"} className={style.login}>
            {'НАТИСНІТЬ ТУТ, ЩОБ ПОВЕРНУТИСЯ НА ПЛАТФОРМУ'}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Logout;
